module.exports = __webpack_public_path__ + "static/media/time_sitesearchstats1.2d6a8f80.png";